import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import io from 'socket.io-client';

const WebSocketContext = createContext(null);

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) throw new Error('useWebSocket debe ser usado dentro de WebSocketProvider');
  return context;
};

export const WebSocketProvider = ({ children, userId, token, idCommerce }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Si no hay datos de usuario, no intentamos conectar
    if (!userId || !token || !idCommerce) return;

    // Conectamos al servidor Node.js (Puerto 3005)

    // process.env.REACT_APP_URL_SOCKET ||"http://192.168.1.10:3005"
    const newSocket = io(process.env.REACT_APP_URL_SOCKET, {
      path: '/plink/v2/socket.io/',
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5
    });

    // AÑADE ESTA LÍNEA AQUÍ
    window.socket = newSocket;

    newSocket.on('connect', () => {
      console.log('Conectado al servidor de sockets');
      setIsConnected(true);

      // REGISTRO: Le decimos al servidor quiénes somos
      newSocket.emit('register_user', {
        userId,
        idCommerce,
        token
      });
    });

    newSocket.on('disconnect', (reason) => {
      console.log('Socket desconectado del servidor:', reason);
      setIsConnected(false);
      // if (reason === "transport close" || reason === "io server disconnect") {
        alert("La conexión con el servidor se ha perdido. Serás redirigido al login.");

        // Limpiamos storage y redirigimos
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      // }

     });

    setSocket(newSocket);

    // Limpieza al desmontar el componente (o cerrar sesión manual)
    return () => {
      if (newSocket) newSocket.close();
    };
  }, [userId, token, idCommerce]);

  // Funciones de ayuda
  const emitEvent = (eventName, data) => {
    if (socket?.connected) socket.emit(eventName, { ...data, userId });
  };

  return (
    <WebSocketContext.Provider value={{ socket, isConnected, emitEvent }}>
      {children}
    </WebSocketContext.Provider>
  );
};